import React from "react"
import { getProductTypeOptionsSelector } from "../../../../../reducers/ProductTypes/productTypes"
import { getDistributionCenterProductTypes } from "../../../../../utils/distributionCenter"
import { useDispatch, useSelector } from "react-redux"
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"
import { Button } from "@mui/material"
import { makeStyles } from "@mui/styles"
import DistributionCentersProductTypeSettingsForm, { distributionCenterProductTypeSettingsFormId } from "./DistributionCenterProductTypeSettingsForm"
import { editDistributionCenterSettings } from "../../../../../actions/Planning/Settings/PlanningSettingsDistributionCenters"
import { COLORS } from "../../../../../utils"

const useStyles = makeStyles(() => ({
  dialogPaper: {
    width: 664,
    paddingTop: "32px",
    paddingBottom: "32px",
    overflow: "hidden"
  },
  title: {
    padding: 0,
    paddingBottom: "40px",
    paddingLeft: "32px",
    paddingRight: "32px"
  },
  content: {
    paddingLeft: "20px",
    marginLeft: "12px",
    marginRight: "12px",
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: `${COLORS.BLACK_500} transparent`,
    "&::-webkit-scrollbar": {
      width: "8px"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: COLORS.BLACK_500
    }
  },
  actions: {
    justifyContent: "space-between",
    paddingLeft: "32px",
    paddingRight: "32px",
    paddingBottom: 0,
    paddingTop: "12px",
    borderTop: "1px solid #E6E6E6"
  }
}))

const DistributionCenterProductTypeSettingsFormContainer = ({ open, onClose, distributionCenter }) => {

	const classes = useStyles()
	const dispatch = useDispatch()
	const productTypeOptions = useSelector(getProductTypeOptionsSelector)

	const onSubmitAttachRatesForm = (values) => {

		const productTypes = getDistributionCenterProductTypes(productTypeOptions, ["ALL"])

		const formattedDispatch = {}
		productTypes.forEach(({ value: type }) => {
			formattedDispatch[type] = {
				min: values.dispatch?.[type]?.min ?? null,
				max: values.dispatch?.[type]?.max ?? null,
				reusable: values.dispatch?.[type]?.reusable ?? 0
			}
		})

		// Preserve priority
		const currentPriority = distributionCenter.dispatch?.priority ?? 999 // fallback to a default value – this should never be triggered in normal flow
		formattedDispatch.priority = currentPriority

		dispatch(editDistributionCenterSettings(distributionCenter.objectId, {
			attachRates: values.attachRates,
			dispatch: formattedDispatch
		}, "attachRates"))

		onClose && onClose()
	}

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth={false}
			PaperProps={{ className: classes.dialogPaper }}
		>
			
			<DialogTitle  className={classes.title}>
				Modifier le paramétrage des types de produit
			</DialogTitle>
			<DialogContent className={classes.content}>
				<DistributionCentersProductTypeSettingsForm
					distributionCenter={distributionCenter}
					handleSubmit={onSubmitAttachRatesForm}
					productTypeOptions={productTypeOptions}
				/>
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button
					onClick={onClose}
				>
					Annuler
				</Button>
				<Button
					color="primary"
					variant="contained"
					type="submit"
					form={distributionCenterProductTypeSettingsFormId}
				>
					Enregistrer
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default DistributionCenterProductTypeSettingsFormContainer